import React, { FC, useEffect } from "react";
import { ReactSVG } from "react-svg";
import useAppSelector from "../hooks/useAppSelector";
import useAppDispatch from "../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";

import {
  getBonusSummaryList,
  getWalletBalanceList,
} from "../store/action/wallet";
import { Link } from "react-router-dom";

const ProfileWalletInfo: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const userState = useAppSelector((state) => state.user);
  const walletState = useAppSelector((state) => state.wallet);

  const getWalletBalanceLists = async () => {
    await dispatch(getWalletBalanceList(userState.memberId));
  };

  useEffect(() => {
    getWalletBalanceLists();
  }, []);

  return (
    <>
      <div className="container">
        {userState.fullname && userState.rank_Name && (
          <div className="row gx-1s">
            <div className="col-8 d-flex flex-column">
              <span className="my-1 fs-6">{t("hello")},</span>
              <span className="my-1 font-weight-500 font-size-32 color-mint lh-1">
                {userState.fullname}
              </span>
              <span className="my-1 h6">{userState.rank_Name}</span>
            </div>
            {/*<div className="col-4 d-flex align-items-center justify-content-end">*/}
            {/*  <img*/}
            {/*    src={process.env.PUBLIC_URL + "/assets/img/profile.png"}*/}
            {/*    className="img-fluid"*/}
            {/*    alt="profileImg"*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        )}

        <div className="row g-1">
          {walletState.walletBalanceList.map((item, index) => {
            if (item.walletName === "Share") {
              return (
                <Link
                  className="col-12 mt-3 mb-4"
                  key={index}
                  to={
                    process.env.PUBLIC_URL +
                    `/wallet/transaction/${item.walletName}`
                  }
                >
                  <div className="border rounded h-auto p-2 shadow-sm">
                    <div className="row p-2 gx-3 d-flex align-items-baseline">
                      <div className="col-auto align-self-center">
                        <ReactSVG
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/img/icons/shareWallet.svg"
                          }
                        />
                      </div>
                      <div className="col-auto">
                        <span className="font-size-45 font-weight-500 color-mint">
                          {item.balance.toFixed(2)}
                        </span>
                      </div>
                      <div className="col-auto">
                        <span className="fs-6 space-mt--15">Share Wallet</span>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            } else
              return (
                <Link
                  className="col-4 mt-3"
                  key={index}
                  to={process.env.PUBLIC_URL + `/wallet/${item.walletName}`}
                >
                  <div className="border rounded ps-2 py-1 shadow-sm d-flex flex-column align-items-start text-break">
                    <span className="fs-5">{item.walletName}</span>
                    <span className="color-mint  font-size-18">
                      {item.balance.toFixed(2)}
                    </span>
                  </div>
                </Link>
              );
          })}
        </div>
      </div>
    </>
  );
};

export default ProfileWalletInfo;
